import { Link } from '@tanstack/react-router';
import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss';

export type CertificateButtonProps = {
  fileRedirectUrl?: string;
  disabled: boolean;
};

export const CertificateButton = ({
  fileRedirectUrl,
  disabled,
}: CertificateButtonProps) => {
  return (
    <Link
      to={fileRedirectUrl}
      target="_blank"
      className={classNames(styles.certificateButton, {
        [styles.disabled]: disabled,
        primaryShadow: !disabled,
      })}
      disabled={disabled}
    >
      <svg
        viewBox="0 0 32 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
      >
        <title>Certificate Icon</title>
        <path
          d="M28 21.8334V13.9667L17.2667 19.8C16.8667 20.0223 16.4445 20.1334 16 20.1334C15.5556 20.1334 15.1334 20.0223 14.7334 19.8L3.46672 13.6667C3.22227 13.5334 3.05005 13.3667 2.95005 13.1667C2.85005 12.9667 2.80005 12.7445 2.80005 12.5C2.80005 12.2556 2.85005 12.0334 2.95005 11.8334C3.05005 11.6334 3.22227 11.4667 3.46672 11.3334L14.7334 5.20003C14.9334 5.08892 15.1389 5.00559 15.35 4.95003C15.5612 4.89448 15.7778 4.8667 16 4.8667C16.2223 4.8667 16.4389 4.89448 16.65 4.95003C16.8612 5.00559 17.0667 5.08892 17.2667 5.20003L29.9667 12.1334C30.1889 12.2445 30.3612 12.4056 30.4834 12.6167C30.6056 12.8278 30.6667 13.0556 30.6667 13.3V21.8334C30.6667 22.2111 30.5389 22.5278 30.2834 22.7834C30.0278 23.0389 29.7112 23.1667 29.3334 23.1667C28.9556 23.1667 28.6389 23.0389 28.3834 22.7834C28.1278 22.5278 28 22.2111 28 21.8334ZM14.7334 27.8L8.06672 24.2C7.62227 23.9556 7.27783 23.6223 7.03338 23.2C6.78894 22.7778 6.66672 22.3223 6.66672 21.8334V16.7667L14.7334 21.1334C15.1334 21.3556 15.5556 21.4667 16 21.4667C16.4445 21.4667 16.8667 21.3556 17.2667 21.1334L25.3334 16.7667V21.8334C25.3334 22.3223 25.2112 22.7778 24.9667 23.2C24.7223 23.6223 24.3778 23.9556 23.9334 24.2L17.2667 27.8C17.0667 27.9111 16.8612 27.9945 16.65 28.05C16.4389 28.1056 16.2223 28.1334 16 28.1334C15.7778 28.1334 15.5612 28.1056 15.35 28.05C15.1389 27.9945 14.9334 27.9111 14.7334 27.8Z"
          fill="currentColor"
        />
      </svg>

      <span>修了証</span>
    </Link>
  );
};
